import { useParams } from 'react-router-dom'
import PermissionSection from './PermissionSection'

export default function ResourcePermissions() {
    const { resource, id } = useParams()
    return <PermissionSection resource={resource} id={id} />
}
